import Storage from './Storage';

class AuthUtils {
  static getAuthToken(): any {
    return Storage.getItem(Storage.KEYS.AUTH_TOKEN);
  }

  static clearAuthToken(): void {
    Storage.removeItem(Storage.KEYS.AUTH_TOKEN);
  }

  static setAuthToken(token: any): void {
    this.clearAuthToken();
    Storage.setItem(Storage.KEYS.AUTH_TOKEN, token);
  }

  static clearUserAccess(): void {
    Storage.removeItem(Storage.KEYS.USER_GROUP);
  }

  static setUserAccess(name: any): void {
    this.clearUserAccess();
    Storage.setItem(Storage.KEYS.USER_GROUP, name);
  }

  static getUserAccess(): any {
    return Storage.getItem(Storage.KEYS.USER_GROUP);
  }

  static getSelectedModuleName(): any {
    return Storage.getItem(Storage.KEYS.SELECTED_MODULE_NAME);
  }

  static clearSelectedModuleName(): void {
    Storage.removeItem(Storage.KEYS.SELECTED_MODULE_NAME);
  }

  static setSelectedModuleName(module: any): void {
    this.clearSelectedModuleName();
    Storage.setItem(Storage.KEYS.SELECTED_MODULE_NAME, module);
  }

  static getSelectedCheckBoxData(): any {
    return Storage.getItem(Storage.KEYS.SELECTED_CHECK_BOX);
  }

  static clearSelectedCheckBoxData(): void {
    Storage.removeItem(Storage.KEYS.SELECTED_CHECK_BOX);
  }

  static setSelectedCheckBoxData(data: any): void {
    this.clearSelectedCheckBoxData();
    Storage.setItem(Storage.KEYS.SELECTED_CHECK_BOX, data);
  }
  static getSelectedPatientAccountingCheckBoxData(): any {
    return Storage.getItem(Storage.KEYS.SELECTED_PATIENT_ACCOUNTING_CHECK_BOX);
  }

  static clearSelectedPatientAccountingCheckBoxData(): void {
    Storage.removeItem(Storage.KEYS.SELECTED_PATIENT_ACCOUNTING_CHECK_BOX);
  }

  static setSelectedPatientAccountingCheckBoxData(data: any): void {
    this.clearSelectedPatientAccountingCheckBoxData();
    Storage.setItem(Storage.KEYS.SELECTED_PATIENT_ACCOUNTING_CHECK_BOX, data);
  }
  static getSelectedAdditionalCheckBoxData(): any {
    return Storage.getItem(Storage.KEYS.SELECTED_ADDITIONAL_CHECK_BOX);
  }

  static clearSelectedAdditionalCheckBoxData(): void {
    Storage.removeItem(Storage.KEYS.SELECTED_ADDITIONAL_CHECK_BOX);
  }

  static setSelectedAdditionalCheckBoxData(data: any): void {
    this.clearSelectedAdditionalCheckBoxData();
    Storage.setItem(Storage.KEYS.SELECTED_ADDITIONAL_CHECK_BOX, data);
  }
  static getSelectedCheckBoxList(): any {
    return Storage.getItem(Storage.KEYS.SELECTED_CHECKBOX_LIST, true);
  }

  static clearSelectedCheckBoxList(): void {
    Storage.removeItem(Storage.KEYS.SELECTED_CHECKBOX_LIST);
  }

  static setSelectedCheckBoxList(list: any): void {
    this.clearSelectedCheckBoxList();
    Storage.setItem(Storage.KEYS.SELECTED_CHECKBOX_LIST, list);
  }
  static getPatientAccountingSelectedCheckBoxList(): any {
    return Storage.getItem(
      Storage.KEYS.SELECTED_PATIENT_ACCOUNTING_CHECKBOX_LIST,
      true
    );
  }

  static clearPatientAccountingSelectedCheckBoxList(): void {
    Storage.removeItem(Storage.KEYS.SELECTED_PATIENT_ACCOUNTING_CHECKBOX_LIST);
  }

  static setPatientAccountingSelectedCheckBoxList(list: any): void {
    this.clearPatientAccountingSelectedCheckBoxList();
    Storage.setItem(
      Storage.KEYS.SELECTED_PATIENT_ACCOUNTING_CHECKBOX_LIST,
      list
    );
  }
  static getAdditionalSelectedCheckBoxList(): any {
    return Storage.getItem(
      Storage.KEYS.SELECTED_ADDITIONAL_CHECKBOX_LIST,
      true
    );
  }

  static clearAdditionalSelectedCheckBoxList(): void {
    Storage.removeItem(Storage.KEYS.SELECTED_ADDITIONAL_CHECKBOX_LIST);
  }

  static setSelectedAdditionalCheckBoxList(list: any): void {
    this.clearAdditionalSelectedCheckBoxList();
    Storage.setItem(Storage.KEYS.SELECTED_ADDITIONAL_CHECKBOX_LIST, list);
  }
  static getSelectedLoginType(): any {
    return Storage.getItem(Storage.KEYS.SELECTED_LOGIN_TYPE);
  }

  static clearSelectedLoginType(): void {
    Storage.removeItem(Storage.KEYS.SELECTED_LOGIN_TYPE);
  }

  static setSelectedLoginType(type: any): void {
    this.clearSelectedLoginType();
    Storage.setItem(Storage.KEYS.SELECTED_LOGIN_TYPE, type);
  }

  static getIsAzureAuthenticated(): any {
    return Storage.getItem(Storage.KEYS.IS_AZURE_AUTHENTICATED);
  }

  static clearIsAzureAuthenticated(): void {
    Storage.removeItem(Storage.KEYS.IS_AZURE_AUTHENTICATED);
  }

  static setIsAzureAuthenticated(type: boolean): void {
    this.clearIsAzureAuthenticated();
    Storage.setItem(Storage.KEYS.IS_AZURE_AUTHENTICATED, type);
  }

  static getEpicTokenUrl(): any {
    return Storage.getItem(Storage.KEYS.EPIC_TOKEN_URL);
  }

  static getAthenaTokenUrl(): any {
    return Storage.getItem(Storage.KEYS.ATHENA_TOKEN_URL);
  }

  static clearEpicTokenUrl(): void {
    Storage.removeItem(Storage.KEYS.EPIC_TOKEN_URL);
  }

  static clearAthenaTokenUrl(): void {
    Storage.removeItem(Storage.KEYS.ATHENA_TOKEN_URL);
  }

  static setEpicTokenUrl(tokenUrl: string): void {
    this.clearEpicTokenUrl();
    Storage.setItem(Storage.KEYS.EPIC_TOKEN_URL, tokenUrl);
  }

  static setAthenaTokenUrl(tokenUrl: string): void {
    this.clearAthenaTokenUrl();
    Storage.setItem(Storage.KEYS.ATHENA_TOKEN_URL, tokenUrl);
  }

  static clearSelectedDocID(): void {
    Storage.removeItem(Storage.KEYS.DOC_ID);
  }

  static setSelectedDocID(id: any): void {
    this.clearSelectedDocID();
    Storage.setItem(Storage.KEYS.DOC_ID, id);
  }

  static getSelectedDocID(): any {
    return Storage.getItem(Storage.KEYS.DOC_ID);
  }

  static clearEpicPatientId(): void {
    Storage.removeItem(Storage.KEYS.EPIC_PATIENT_ID);
  }

  static clearAthenaPatientId(): void {
    Storage.removeItem(Storage.KEYS.ATHENA_PATIENT_ID);
  }

  static setEpicPatientId(id: any): void {
    this.clearEpicPatientId();
    Storage.setItem(Storage.KEYS.EPIC_PATIENT_ID, id);
  }

  static setAthenaPatientId(id: any): void {
    this.clearAthenaPatientId();
    Storage.setItem(Storage.KEYS.ATHENA_PATIENT_ID, id);
  }

  static getEpicPatientId(): any {
    return Storage.getItem(Storage.KEYS.EPIC_PATIENT_ID);
  }

  static getAthenaPatientId(): any {
    return Storage.getItem(Storage.KEYS.ATHENA_PATIENT_ID);
  }

  static clearAuditIdentifier(): void {
    Storage.removeItem(Storage.KEYS.AUDIT_IDENTIFIER);
  }

  static setAuditIdentifier(identifier: any): void {
    this.clearAuditIdentifier();
    Storage.setItem(Storage.KEYS.AUDIT_IDENTIFIER, identifier);
  }

  static getAuditIdentifier(): any {
    return Storage.getItem(Storage.KEYS.AUDIT_IDENTIFIER);
  }

  static clearAuditIdentifierType(): void {
    Storage.removeItem(Storage.KEYS.AUDIT_IDENTIFIER_TYPE);
  }

  static setAuditIdentifierType(identifierType: any): void {
    this.clearAuditIdentifierType();
    Storage.setItem(Storage.KEYS.AUDIT_IDENTIFIER_TYPE, identifierType);
  }

  static getAuditIdentifierType(): any {
    return Storage.getItem(Storage.KEYS.AUDIT_IDENTIFIER_TYPE);
  }

  static clearAuditLegacyApp(): void {
    Storage.removeItem(Storage.KEYS.AUDIT_LEGACY_APP);
  }

  static setAuditLegacyApp(legacyApp: any): void {
    this.clearAuditLegacyApp();
    Storage.setItem(Storage.KEYS.AUDIT_LEGACY_APP, legacyApp);
  }

  static getAuditLegacyApp(): any {
    return Storage.getItem(Storage.KEYS.AUDIT_LEGACY_APP);
  }

  static clearPrevRoute(): void {
    Storage.removeItem(Storage.KEYS.PREV_ROUTE);
  }

  static setPrevRoute(prevRoute: string): void {
    this.clearPrevRoute();
    Storage.setItem(Storage.KEYS.PREV_ROUTE, prevRoute);
  }

  static getPrevRoute(): any {
    return Storage.getItem(Storage.KEYS.PREV_ROUTE);
  }

  static clearPermissions(): void {
    Storage.removeItem(Storage.KEYS.PERMISSIONS);
  }

  static setPermissions(permissions: any): void {
    this.clearPermissions();
    Storage.setItem(Storage.KEYS.PERMISSIONS, permissions);
  }

  static getPermissions(): any {
    return Storage.getItem(Storage.KEYS.PERMISSIONS, true);
  }
  static clearUserAppPermissions(): void {
    Storage.removeItem(Storage.KEYS.USER_APP_PERMISSION);
  }

  static setUserAppPermissions(userpermissions: any): void {
    this.clearUserAppPermissions();
    Storage.setItem(Storage.KEYS.USER_APP_PERMISSION, userpermissions);
  }

  static getUserAppPermissions(): any {
    return Storage.getItem(Storage.KEYS.USER_APP_PERMISSION, true);
  }
  static clearRedirectRoute(): void {
    Storage.removeItem(Storage.KEYS.REDIRECT_ROUTE);
  }

  static setRedirectRoute(route: string): void {
    this.clearRedirectRoute();
    Storage.setItem(Storage.KEYS.REDIRECT_ROUTE, route);
  }

  static getRedirectRoute(): any {
    return Storage.getItem(Storage.KEYS.REDIRECT_ROUTE);
  }

  static setApplication(applicationName: string): void {
    Storage.setItem(Storage.KEYS.APPLICATION_NAME, applicationName);
  }

  static getApplicationName(): any {
    return Storage.getItem(Storage.KEYS.APPLICATION_NAME);
  }

  static setAzureRedirected(isRedirected: boolean): void {
    Storage.setItem(Storage.KEYS.IS_AZURE_REDIRECTED, isRedirected);
  }

  static getAzureRedirected(): any {
    return Storage.getItem(Storage.KEYS.IS_AZURE_REDIRECTED);
  }

  static clearStorage(data?: {skip?: string[]}): void {
    const skipKeys = data?.skip ?? [];
    const skipObject: Record<string, string | null> = {};

    // Preserve specified keys
    for (const key of skipKeys) {
      skipObject[key] = Storage.getItem(key);
    }

    // Clear all storage
    Storage.clear();
    Storage.sessionClear();

    // Restore preserved keys
    for (const key in skipObject) {
      if (skipObject[key] !== null) {
        Storage.setItem(key, skipObject[key]!);
      }
    }
  }

  // For Debugging Purposes
  static printStorage(): void {
    Storage.printStorage();
  }
}

export default AuthUtils;
